import React, { FC } from 'react'

import { EuiTitle, EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiText, EuiButtonIcon, EuiSpacer } from '@elastic/eui'

import { MasterCampaignPlanCustomSection } from 'api/entities/MasterCampaignPlan'

export interface CustomizableSectionProps {
  section: MasterCampaignPlanCustomSection | null | undefined
  defaultTitle: string
  defaultContent: string
  defaultShowTitle: boolean
  separator: 'horizontalRule' | 'spacer'
  titleSize?: 's' | 'm' | 'l'
}

const CustomizableSection: FC<CustomizableSectionProps> = ({ section, defaultTitle, defaultContent, defaultShowTitle, separator, titleSize = 's' }) => {
  if (section?.hideAll === true) {
    return null
  }

  const title = section?.title ?? defaultTitle
  const content = section?.content ?? defaultContent
  const showTitle = section?.showTitle ?? defaultShowTitle

  const shouldShowTitle = showTitle && title && title.length > 0

  if (shouldShowTitle) {
    return (
      <>
        <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
          <EuiFlexItem grow={false}>
            <EuiTitle size='s'>
              <h4>{title}</h4>
            </EuiTitle>
          </EuiFlexItem>
        </EuiFlexGroup>

        {separator === 'spacer' && <EuiSpacer size='m' />}
        {separator === 'horizontalRule' && <EuiHorizontalRule margin='s' />}

        <EuiText style={{ whiteSpace: 'pre-wrap' }}>
          <p>{content}</p>
        </EuiText>
      </>
    )
  }

  return (
    <>
      <EuiText style={{ whiteSpace: 'pre-wrap' }}>
        <p>{content}</p>
      </EuiText>
    </>
  )
}

export default CustomizableSection
